import styled from 'styled-components';

import { Callout } from '@/nova/components';

// The shared Callout carries the tint, border, leading glyph and role=status; only the placement
// margin inside the studio chrome is layout-local, so wrap rather than re-implement the notice strip.
export const Banner = styled(Callout)`
  margin: 12px 16px 0;
`;
